<template>
	<div class="copy_content" :class="copyBodyClass">
		<!-- <p>&copy; 上海摩泛科技有限公司 <span v-if="!isMobile">All Rights Reserved. Designed by Shanghai Mofan Technology Co., Ltd.</span></p>
		<p>  </p> -->
		<div class="copyRight_left">
			<div class="company_name">© 上海摩泛科技有限公司</div>
			<div class="footer_navs">
				<div class="footer_nav" v-for="nav in navs" :key="nav.text" @click="onNavLink(nav)"> {{$t(nav.text)}} </div>
			</div>
			<div class="menu_list">
				<div class="menu_title">{{ $t('copyRight.guanzhuwomen') }}</div>
				<div class="icon_list">
					<div class="icon_img_box">
						<img class="icon_img" src="@/assets/footer/wechat.png" alt="">
						<div class="icon_hover_box">
							<img class="icon_hover_img" src="@/assets/wechat_qrcode.png" alt="">
						</div>
					</div>
					<div class="icon_img_box">
						<img class="icon_img" src="@/assets/footer/redbook.png" alt="">
						<div class="icon_hover_box">
							<img class="icon_hover_img" src="@/assets/mogine_red_book.png" alt="">
						</div>
					</div>
					<div class="icon_img_box">
						<img class="icon_img" src="@/assets/footer/bilibili.png" alt="">
						<div class="icon_hover_box">
							<img class="icon_hover_img" src="@/assets/bilibili_qrcode.png" alt="">
						</div>
					</div>
					<div class="icon_img_box">
						<img class="icon_img" src="@/assets/footer/douying.png" alt="">
						<div class="icon_hover_box">
							<img class="icon_hover_img" src="@/assets/douying_qrcode.png" alt="">
						</div>
					</div>
					<div class="icon_img_box">
						<img class="icon_img" src="@/assets/footer/weibo.png" alt="">
						<div class="icon_hover_box">
							<img class="icon_hover_img" src="@/assets/weibo_qrcode.png" alt="">
						</div>
					</div>
					
				</div>
			</div>
		</div>
		
		<div class="copyRight_right">
			<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902002921" style="text-decoration:none;height:20px;line-height:20px;">
				<img src="@/assets/gongan.png" style="vertical-align:bottom;"/>
				沪公网安备 31010902002921号
			</a> 
				&nbsp;&nbsp;&nbsp;
			<a href=" http://beian.miit.gov.cn/" target="_blank" >
				沪ICP备18014516号-6
			</a>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: ['tema'],
		data: () => ({
			
			navs: [
				{ text: 'copyRight.yinsishenmin', path: null },
				{ text: 'copyRight.fukuanxieyi', path: null },
				{ text: 'copyRight.yonghuxiyi', path: null },
				{ text: 'copyRight.cookiexiyi', path: null },
				{ text: 'copyRight.wentifankui', path: null },
				{ text: 'copyRight.lianxiwomen', path: '/serve' },
			]
			
		}),
		computed:{
			copyBodyClass() {
				let { tema, themeClass } = this
				let obj = {}
				if (tema) obj[tema] = true
				if (themeClass) obj['black-theme'] = true
				return obj
			}
		},
		methods: {
			onNavLink(nav) {
				if (nav.path) {
					this.$router.push(nav.path)
				} else {
					this.$message.default('网页制作中，敬请期待！')
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.copy_content{
		font-size: 12px;
		bottom:0;
		width: 100%;
		height: 60px;
		line-height: 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		color: rgba(171, 174, 180, 1);
		padding: 22px 40px;
		background-color: rgba(26, 26, 26, 1);
		a{
			color: rgba(171, 174, 180, 1);
		}
		.copyRight_left{
			display: flex;
			align-items: center;
			.company_name{
				margin-right: 9px;
			}
			.footer_navs{
				display: flex;
				
				.footer_nav{
					margin: 0 12px;
					position: relative;
					cursor: pointer;
					&:after{
						content: '';
						width: 1px;
						height: 16px;
						border-right: 1px solid rgba(171,174,180,1);
						display: block;
						position: absolute;
						right: -12px;
						top: 50%;
						transform: translateY(-50%);
					}
					&:last-child{
						&:after{
							display: none;
						}
					}
				}
			}
		}
		.menu_list{
			font-size: 12px;
			line-height: .32rem;
			display: flex;
			align-items: center;
			.menu_title{
				font-size: 12px;
				margin-right: 31px;
			}
			.menu_item{
				cursor: pointer;
				color: #777c84;
				&:hover{
					color: #fff;
				}
			}
			.icon_list{
				display: flex;
				.icon_img_box{
					width: .24rem;
					position: relative;
					margin-right: .15rem;
					line-height: 1;
					&:hover{
						.icon_hover_box{
							display: flex;
							position: absolute;
						}
					}
				}
				.icon_img{
					width: 100%;
					display: block;
					cursor: pointer;
					line-height: 1;
				}
				.icon_hover_box{
					display: none;
					position: absolute;
					width: 129px;
					height: 122px;
					background: #fff;
					border-radius: 8px;
					bottom: calc(100% + 18px);
					left: 50%;
					transform: translateX(-70%);
					z-index: 999;
					justify-content: center;
					align-items: center;
					position: relative;
					.icon_hover_img{
						width: 110px;
						display: block;
						position: relative;
						z-index: 1;
						line-height: 1;
					}
					.icon_hover_text{
						text-align: center;
						position: absolute;
						bottom: .24rem;
						font-size: 14px;
						font-weight: 700;
						left:0;
						right:0;
						line-height: .14rem;
					}
					&:after{
						position: absolute;
						top: 100%;
						left: 70%;
						width: 26.38px;
						height: 26.38px;
						transform: translate(-50%, -70%) rotate(45deg) ;
						background-color: #fff;
						border-radius: 4px;
						display: block;
						content: '';
						z-index: 0;
					}
					&:before{
						position: absolute;
						top: 100%;
						left: 70%;
						width: 26.38px;
						height: 26.38px;
						transform: translate(-50%, -20%);
						background-color: transparent;
						border-radius: 4px;
						display: block;
						content: '';
						z-index: 0;
					}
				}
			}
		}
	}
	@media screen and (max-width: 760px) {
		.copy_content{
			flex-direction: column;
			height: auto;
			.copyRight_left{
				flex-direction: column;
				.footer_navs{
					flex-wrap: wrap;
					justify-content: center;
					margin-bottom: 12px;
					.footer_nav{
						margin: 0 8px;
					}
				}
			}
			.menu_list{
				margin: 12px 0;
				.icon_list{
					.icon_img_box{
						width: 24px;
					}
				}
			}
			
			.copyRight_right{
				text-align: center;
			}
		}
	}
</style>